import React from "react";
import { findDOMNode } from "react-dom";
import imgLogo from "../../assets/images/cal-logo.svg";
import imgRightArrow from "../../assets/images/rightArrow.svg";
import imgClose from "../../assets/images/icon-x.svg";
import "../../assets/styles/title.css";
import imgMenu from "../../assets/images/hamburger.svg";
import { setHeaders } from "../../actions/services";
import { setStage, Stages } from "../../actions/actions";
import axios from "axios";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";
import { getStepData } from "../../../src/actions/gtmService";

export default class Title extends React.Component {
  componentDidUpdate() {
    if (this.props.focusOn == "title") {
      let title = findDOMNode(this.refs.title);
      title.scrollIntoView();
      title.focus();
      Stages.this.props.onFocus(null);
    }
  }

  render() {
    let { stage } = this.props;

    const getRightArrow = () => {
      switch (stage) {
        case Stages.cards:
        case Stages.loader:
        case Stages.error:
          return (
            <img
              alt="חזרה"
              className="pointer"
              onClick={() => {
                const { step_number, step_titel } = getStepData();
                sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
                  process_type: gtmConstant.SecretCode.PROCESS_NAME,
                  step_titel,
                  step_number,
                  click_text: "חזרה", 
                });
                this.props.onGoBack();
              }}
              src={imgRightArrow}
            />
          );

        case Stages.pin:
          return (
            <img
              alt="חזרה"
              className="pointer"
              onClick={() => {
                const { step_number, step_titel } = getStepData();
                sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
                  process_type: gtmConstant.SecretCode.PROCESS_NAME,
                  step_titel,
                  step_number,
                  click_text: "חזרה", 
                });
                this.props.gotToCardsPage();
              }}
              src={imgRightArrow}
            />
          );

        default:
          return null;
      }
    };

    const getBitOrLeumiDesign = () => {
      let titleHeader;
      let leftElement;
      let rightElement;
      //let leumiLogo = "themes/" +this.props.provider + "/images/logo_provider_header.png";
      let leumiLogo = "";//remove leumi logo after enter paper bank
      let logoImage =  this.props.provider!=="leumi" ? (
        <img
          className="logo-image"
          src={
            this.props.isCalProvider
             ? imgLogo
              : leumiLogo
          }
          alt="לוגו כרטיסי אשראי לישראל"
        />
      ):"";

      if (this.props.provider != "bit") {
        rightElement = (
          <button
            className="btn-sidebar"
            onClick={() => {
              this.props.onOpenMenu(true);
            }}
            aria-label="תפריט"
          >
            <img src={imgMenu} />
          </button>
        );
        titleHeader = (
          <span className="navbar-brand brand-color" ref="title" tabIndex="-1">
            צפייה בקוד הסודי
          </span>
        );
        leftElement = logoImage;
      } else {
        titleHeader = (
          <span>
            <img
              className="bit-image"
              src={
                this.props.isCalProvider
                  ? imgLogo
                  : "themes/" +
                    this.props.provider +
                    "/images/logo_provider_header.png"
              }
              alt="לוגו ביט"
            />
          </span>
        );
        rightElement = (
          <span
            className="navbar-cal-bit brand-color"
            ref="title"
            tabIndex="-1"
          >
            <img
              className="logo-image"
              src={
                "themes/" + this.props.provider + "/images/Cal-logo-white.png"
              }
            />
          </span>
        );
      }

      return renderBitOrLeumiDesign(titleHeader, rightElement, leftElement);
    };

    const renderBitOrLeumiDesign = (titleHeader, rightElement, leftElement) => {
      return (
        <nav className="bit-or-leumi-header-wrap bg-a navbar navbar-main">
          <div className="navbar-header bg-n">
            {rightElement}
            {titleHeader}
            <div
              className="btn btn-link navbar-logo"
              role="link"
              onClick={() => {
                this.props.isConnected
                  ? this.props.onLogout(window.settings.provider.homeSiteUrl)
                  : this.props.onExit(
                      window.settings.provider.homeSiteUrl,
                      false
                    );
              }}
              aria-label={
                this.props.isCalProvider
                  ? "עבור לאתר כרטיסי אשראי לישראל"
                  : "עבור לאתר בנק לאומי"
              }
            >
              {leftElement}
            </div>
          </div>
        </nav>
      );
    };

    const getCalDesign = () => {
      let titleHeader;
      let leftElement;
      let rightElement;

      let closeImage = (
        <img
          className="pointer"
          onClick={() => {
            const { step_number, step_titel } = getStepData();
            sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
              process_type: gtmConstant.SecretCode.PROCESS_NAME,
              step_titel,
              step_number,
              click_text: "יציאה",
            });

            this.props.onLogout(null, Stages.login);
          }}
          src={imgClose}
          alt="יציאה"
        />
      );

      rightElement = getRightArrow();
      titleHeader = "";

      if (stage !== Stages.thankYou) {
        titleHeader = (
          <span className="navbar-brand brand-color" ref="title" tabIndex="-1">
            צפייה בקוד הסודי
          </span>
        );
      }
      leftElement = closeImage;

      return renderCalDesign(titleHeader, rightElement, leftElement);
    };

    const renderCalDesign = (titleHeader, rightElement, leftElement) => {
      if (stage === Stages.login) {
        leftElement = "";
      }
      if (stage !== Stages.thankYou) {
        titleHeader;
      }
      if (window.hidenavbar == "false" || window.hidenavbar == false)
        return (
          <div className="header-wrap">
            {rightElement}
            <div className="center-content">
              <img
                className="logo-image"
                src={"themes/" + this.props.provider + "/images/cal.svg"}
              ></img>
              <div>{titleHeader}</div>
            </div>
            {leftElement}
          </div>
        );
      else return "";
    };
    setHeaders(this.props.provider);
    if (this.props.provider === "default") {
      return getCalDesign();
    } else {
      return getBitOrLeumiDesign();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/Title.jsx